import {ModuleWithProviders} from "@angular/core"
import {Routes, RouterModule} from '@angular/router';
import {UsuariosListComponent} from './list/usuarios.list.component'
import {UsuariosEditorComponent} from './editor/usuarios.editor.component'


export const routes: Routes = [
  {
    path: '', redirectTo: 'list', pathMatch: 'full'
  },
  {
    path: 'list',
    component:UsuariosListComponent,
  },
  {
    path: 'edit',
    component:UsuariosEditorComponent,
  },
  {
    path: 'edit/:id',
    component:UsuariosEditorComponent,
  }
];

export const routing = RouterModule.forChild(routes);